import { Link } from "react-router-dom";
import { allSpecials, getSpecialFilms } from "@/lib/catalog";

export default function SpecialPreview() {
  const items = allSpecials.slice(0, 2);

  return (
    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-6">
      {items.map((special) => {
        const specialFilms = getSpecialFilms(special);
        return (
          <Link
            key={special.id}
            to={`/specials/${special.id}`}
            className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative aspect-[16/9] w-full overflow-hidden bg-secondary-200">
              <img
                src={special.cover}
                alt={`${special.title} 专题主图`}
                className="h-full w-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/20 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <span className="font-label text-[10px] font-semibold uppercase tracking-[0.2em] text-accent-300">
                  策划专题 · {specialFilms.length} 部片单
                </span>
                <h3 className="mt-1 font-heading text-xl font-extrabold text-background-50 md:text-2xl">
                  {special.title}
                </h3>
              </div>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <p className="font-label text-[11px] uppercase tracking-[0.14em] text-secondary-500">
                {special.subtitle}
              </p>
              <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-foreground-600">
                {special.intro}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3.5">
                <div className="flex items-center gap-1.5">
                  {specialFilms.slice(0, 3).map((film) => (
                    <span key={film.id} className="relative h-9 w-6 overflow-hidden rounded-sm bg-secondary-200">
                      <img src={film.poster} alt={film.title} className="h-full w-full object-cover object-top" />
                    </span>
                  ))}
                  <span className="ml-1 font-label text-[11px] text-foreground-500">
                    等 {specialFilms.length} 部
                  </span>
                </div>
                <span className="flex items-center gap-1 font-label text-[11px] font-semibold text-primary-700">
                  查看片单
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}